import { __extends } from "tslib";
import * as React from 'react';
import { Icon } from '../icon/icon';
import { arrowRight } from '../../icons/processed';
import { namespacedClassnames } from '../../common/namespace-classes';
var DrillMenuItem = /** @class */ (function (_super) {
    __extends(DrillMenuItem, _super);
    function DrillMenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            if (!_this.props.disabled) {
                _this.props.onClick();
            }
        };
        return _this;
    }
    DrillMenuItem.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('drill-menu-item', { disabled: props.disabled }, props.className);
        return (React.createElement("div", { className: classNames, onClick: this.onClick },
            React.createElement("div", { className: 'content' }, props.children),
            React.createElement(Icon, { icon: arrowRight, className: 'arrow-icon' })));
    };
    return DrillMenuItem;
}(React.PureComponent));
export { DrillMenuItem };
//# sourceMappingURL=drill-menu-item.js.map